export default {
    tagsDeleteTags_title: "Eliminar Etiquetas",
    tagsDeleteTags_deleteWarning: "¿Esta seguro que desea eliminar las siguientes etiquetas?",
    tagsDeleteTags_errorSelectTag: "No puede seleccionar una etiqueta que se eliminará",
    tagsDeleteTags_typeToSearch: "Escriba para buscar...",
    tagsDeleteTags_selectTag: "Mover etiquetas anidadas y entidades a",
    tagsDeleteTags_deleted: "Etiquetas eliminadas exitosamente",
};